import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { BaivietAction } from 'src/actions/baiviet.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getBaivietStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

const BaivietLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedBaivietIds, setSelectedBaivietIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { role } = useSelector(state => state.profile);
  const { items, total, filter } = useSelector(state => state.baiviet);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(BaivietAction.updateFilter(payload));
    dispatch(BaivietAction.list(page, limit))
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedBaivietIds;

    if (event.target.checked) {
      newSelectedBaivietIds = items.map((baiviet) => baiviet.id);
    } else {
      newSelectedBaivietIds = [];
    }

    setSelectedBaivietIds(newSelectedBaivietIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedBaivietIds.indexOf(id);
    let newSelectedBaivietIds = [];

    if (selectedIndex === -1) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(selectedBaivietIds, id);
    } else if (selectedIndex === 0) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(selectedBaivietIds.slice(1));
    } else if (selectedIndex === selectedBaivietIds.length - 1) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(selectedBaivietIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(
        selectedBaivietIds.slice(0, selectedIndex),
        selectedBaivietIds.slice(selectedIndex + 1)
      );
    }

    setSelectedBaivietIds(newSelectedBaivietIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, baiviet) => {
    setSelected(baiviet);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(BaivietAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(BaivietAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const approve = async (id, trang_thai_duyet) => {
    const question = trang_thai_duyet == 1 ? "Xác nhận duyệt đơn này?" : "Xác nhận từ chối đơn này?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(BaivietAction.approve(id, { trang_thai_duyet }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setTrangThai = async (id, trang_thai) => {
    const question = trang_thai == 'SUCCESS' ? "Xác nhận đặt trạng thái 'Thành công'?" : "Xác nhận đặt trạng thái 'Thất bại'?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(BaivietAction.setTrangThai(id, { trang_thai }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setColor = (value) => {
    if (value == 'co_noi_bat') return '#FF0000';
    else if (value == 'khong_noi_bat') return '#000000';
    else if (value == 'bai_viet') return '#037319';
    else if (value == 'tin_tuc') return '#0000FF';
    else return '#000000';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Tiêu đề
                </TableCell>
                <TableCell>
                  Loại bài
                </TableCell>
                <TableCell>
                  Hình ảnh
                </TableCell>
                <TableCell>
                  Mô tả ngắn
                </TableCell>
                <TableCell>
                  Ngày tạo
                </TableCell>
                <TableCell>
                  Người đăng
                </TableCell>
                <TableCell>
                  Người chỉnh cuối
                </TableCell>
                <TableCell>
                  Thao tác
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((baiviet, index) => (
                <TableRow
                  hover
                  key={baiviet.id}
                  selected={selectedBaivietIds.indexOf(baiviet.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {baiviet.noi_bat == 1 && <span style={{color: setColor('co_noi_bat'), fontWeight: "bold"}}>[NỔI BẬT]</span>} {baiviet.title}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {baiviet.loai_bai == "bai_viet" && <span style={{color: setColor('bai_viet'), fontWeight: "bold"}}>BÀI VIẾT</span>}
                      {baiviet.loai_bai == "tin_tuc" && <span style={{color: setColor('tin_tuc'), fontWeight: "bold"}}>TIN TỨC</span>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {baiviet.image?.match(/\.(mp4|webm|ogg)$/i) ? (
                          <video src={baiviet.image} controls style={{ width: 150, height: 100 }} />
                      ) : baiviet.image ? (
                          <img style={{height: 100}} src={baiviet.image} alt={baiviet.title ? baiviet.title : ''} />
                      ) : null}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {baiviet.short_description}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(baiviet.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {baiviet.username_dang_bai}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {baiviet.username_chinh_sua_cuoi_cung}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(baiviet.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, baiviet)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.ten_goi_cuoc} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default BaivietLookupDetail;
